import React, { useEffect, useState } from 'react';
import Calendar from 'react-calendar';
import 'react-calendar/dist/Calendar.css';
import { useAuth } from '../../context/AuthContext';
import ModalTailwind from '../../components/ModalTailwind';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faClock } from '@fortawesome/free-solid-svg-icons';
import axios from 'axios';

const CitasUser = () => {
  const { user } = useAuth();
  const [citas, setCitas] = useState([]);
  const [selectedDate, setSelectedDate] = useState(null);
  const [citasDelDia, setCitasDelDia] = useState([]);
  const [modalAbierto, setModalAbierto] = useState(false);

  useEffect(() => {
    const fetchCitas = async () => {
      try {
        if (user?.id) {
          const res = await axios.get(`https://www.fancyplus.digital/api/users/citas/${user.id}`);
          setCitas(Array.isArray(res.data) ? res.data : []);
        }
      } catch (error) {
        console.error('Error al obtener las citas:', error);
      }
    };

    fetchCitas();
  }, [user?.id]);

  const soloFecha = (fechaISO) => new Date(fechaISO).toISOString().split('T')[0];

  const onDateClick = (date) => {
    const fechaStr = date.toISOString().split('T')[0];
    const filtradas = citas.filter((c) => soloFecha(c.fecha) === fechaStr);
    setCitasDelDia(filtradas);
    setSelectedDate(date);
    setModalAbierto(true);
  };

  // Para comparar si la cita ya pasó, considerando fecha y hora
  const citaPasada = (cita) => {
    const citaDateTime = new Date(`${soloFecha(cita.fecha)}T${cita.hora}`);
    const ahora = new Date();
    return citaDateTime < ahora;
  };

  const fechaConCita = ({ date }) => {
    const fechaStr = date.toISOString().split('T')[0];
    return Array.isArray(citas) && citas.some((c) => soloFecha(c.fecha) === fechaStr)
      ? 'bg-green-100 border-2 border-green-500 rounded-xl relative'
      : 'rounded-xl';
  };

  const tileContent = ({ date, view }) => {
    const fechaStr = date.toISOString().split('T')[0];
    if (view === 'month' && Array.isArray(citas)) {
      // Buscar si hay alguna cita en esa fecha
      const citasFecha = citas.filter((c) => soloFecha(c.fecha) === fechaStr);
      if (citasFecha.length > 0) {
        // Si al menos una cita pasó, el icono será rojo, sino verde
        const algunaPasada = citasFecha.some(citaPasada);
        return (
          <div className={`absolute top-1 right-1 ${algunaPasada ? 'text-red-600' : 'text-green-600'}`}>
            <FontAwesomeIcon icon={faClock} size="sm" />
          </div>
        );
      }
    }
    return null;
  };

  return (
    <div className="max-w-4xl mx-auto p-3 rounded-3xl mb-6">
      <h2 className="text-4xl font-extrabold text-center text-blue-800">Citas Médicas</h2>

      <div className="flex justify-center scale-125 mt-12">
        <div className="rounded-3xl overflow-hidden shadow-lg">
          <Calendar
            onClickDay={onDateClick}
            tileClassName={fechaConCita}
            tileContent={tileContent}
          />
        </div>
      </div>

      {/* MODAL */}
      <ModalTailwind
        show={modalAbierto}
        onClose={() => setModalAbierto(false)}
        title={`Citas del ${selectedDate?.toLocaleDateString()}`}
      >

        {citasDelDia.length > 0 ? (
          citasDelDia.map((cita) => (
            <div key={cita.id_cita} className="mb-4 border-b pb-2">
              <p><strong>Médico:</strong> {cita.medico}</p>
              <p><strong>Especialidad:</strong> {cita.especialidad}</p>
              <p><strong>Hora:</strong> {cita.hora}</p>
              <p><strong>Tipo:</strong> {cita.tipo}</p>
              <p><strong>Estado:</strong> {cita.estado}</p>
              <p><strong>Teléfono:</strong> {cita.telefono}</p>
              <p><strong>Síntomas:</strong> {cita.sintomas}</p>
            </div>
          ))
        ) : (
          <p>No hay citas para este día.</p>
        )}

        <div className="flex justify-center mt-6">
          <button
            onClick={() => setModalAbierto(false)}
            className="bg-blue-600 hover:bg-blue-700 text-white font-semibold px-6 py-2 rounded-lg"
          >
            Aceptar
          </button>
        </div>
      </ModalTailwind>
    </div>
  );
};

export default CitasUser;
